<template>
  <div>
    <iframe is="x-frame-bypass" width="100%" allowfullscreen height="800" style="border: none;" :src="`https://amalsolution-dev.com:9192/playbook/${this.activeCategory}/${this.folderName}/`"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      folderName: null
    }
  },
  computed: {
    activeCategory() {
      return this.$route.params.category
    }
  },
  mounted() {
    this.fetchFolderName()
  },
  methods: {
    async fetchFolderName() {
      try {
        const response = await this.$http.get(
          `https://amalsolution-dev.com:9192/folders/${this.activeCategory}`
        )
        this.folderName = response.data[0]
      } catch (error) {
        console.error('Error fetching folder name:', error)
      }
    },
  }
}
</script>